import {HttpClient} from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import {environment} from '@environments/environment';
import {Observable} from 'rxjs';
import {IAuthenticatorSetupVerifyRequest} from '../models/authenticator-setup-verify.request.model';
import {IAuthenticatorSetupVerifyResponse} from '../models/authenticator-setup-verify.response.model';
import {IAuthenticatorSetupResponse} from '../models/authenticator-setup.response.model';

@Injectable({
  providedIn: 'root',
})
export class MfaSetupService {
  private readonly _httpClient = inject(HttpClient);

  private readonly authenticatorSetupURL = `${environment.api.baseUrl}/${environment.api.identity.authenticatorSetup}`;
  private readonly authenticatorSetupVerifyURL = `${environment.api.baseUrl}/${environment.api.identity.authenticatorSetupVerify}`;
  private readonly authenticatorSetupCancelURL = `${environment.api.baseUrl}/${environment.api.identity.authenticatorSetupCancel}`;

  public authenticatorSetup(): Observable<IAuthenticatorSetupResponse> {
    return this._httpClient.post<IAuthenticatorSetupResponse>(this.authenticatorSetupURL, {});
  }

  public authenticatorSetupVerify(
    IAuthenticatorSetupVerifyRequest: IAuthenticatorSetupVerifyRequest
  ): Observable<IAuthenticatorSetupVerifyResponse> {
    return this._httpClient.post<IAuthenticatorSetupVerifyResponse>(
      this.authenticatorSetupVerifyURL,
      IAuthenticatorSetupVerifyRequest
    );
  }

  public authenticatorSetupCancel() {
    return this._httpClient.post(this.authenticatorSetupCancelURL, {});
  }
}
